module.exports = __webpack_public_path__ + "static/media/vu.730801ab.svg";